<template>
  <GenericStep v-bind="$attrs">
    <div
      v-for="narrative of peParty.narratives"
      :key="narrative.id"
      class="mb-12"
    >
      <NarrativesCard
        :item="narrative"
      />
    </div>

    <SectionAdderLine
      section="Narrative"
      :has-new-section="peNarrativesCardHasNewSection"
      @on-add="peNarrativesCardAddSection"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import NarrativesCard from '@/components/Party/PartyEdit/SectionCards/PersonalDataCards/NarrativesCard.vue'
import SectionAdderLine from '@/components/Party/PartyEdit/SectionTools/SectionAdderLine.vue'

export default {
  name: 'NarrativesStep',

  components: {
    GenericStep,
    NarrativesCard,
    SectionAdderLine,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return this.peParty.narratives
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peNarrativesCardHasNewSection',
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peNarrativesCardAddSection',
    ]),
  },
}
</script>
